//TODO move upload services to here

import { USER_COLLECTION } from "config";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";

export const getSpeakers = async (uid: string) => {
    try {
        const user = await getDoc(doc(db, USER_COLLECTION, uid));
        const speakerIds = await user.data()!["vc-speaker-ids"];
        return speakerIds || [];
    } catch (error) {
        throw error;
    }
}